import { ActivityHydrationStateEnum } from '../enums/activity-hydration-state.enum';

/**
 * Resolved before/after records for a hydrated relation field on an activity event.
 */
export class ActivityFieldHydration<T> {
  before?: T;
  after?: T;
  beforeState?: ActivityHydrationStateEnum;
  afterState?: ActivityHydrationStateEnum;
}
